'use client'

import { Suspense } from 'react'

import { useMapSearchParams } from '@/features/search-map'

import { RoomFilter } from './room-filter'
import { RoomFinder } from './room-finder'
import { AirbridgeEventSender } from '../lib/airbridge-event-sender'

export const SearchPageWithoutSuspense = () => {
  useMapSearchParams({ pathname: '/guest/search' })

  return (
    <>
      <AirbridgeEventSender />
      <div className="h-[calc(100vh-72px)] w-screen min-w-[1328px]">
        <RoomFilter />
        <RoomFinder />
      </div>
    </>
  )
}

export const SearchPage = () => {
  return (
    <Suspense>
      <SearchPageWithoutSuspense />
    </Suspense>
  )
}
